export default __webpack_public_path__ + "static/media/logo-small.5f55b3bc.svg";